import { render } from "./ShowMail.vue?vue&type=template&id=4cf0dcaf"
import script from "./ShowMail.vue?vue&type=script&lang=js"
export * from "./ShowMail.vue?vue&type=script&lang=js"

import "./ShowMail.vue?vue&type=style&index=0&id=4cf0dcaf&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__